const counselRoutes = [
  {
    path: "/counsel",
    name: "",
    meta: {
      title: "운영자 화면",
    },
    children: [
      {
        path: "index", // /staff/counsel/index
        name: "counselIndex",
        meta: {
          title: "상담 관리",
        },
        component: () => import("@/views/staff/counsel/CounselManagement.vue"),
      },
    ],
  },
];
export default counselRoutes;
